// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__IRt2c","subTitle":"Faq_subTitle__IhZbI"};